<template lang="pug">
  include ./../../mixins
  +b.modal
    +b.close(
      slot="top-right"
      @click="$emit('close')"
    )
      +b.I.icon.--type_close
    +e.content
      +b.P.text.--fs_xl.--lh_xs.--color_black.--fw_bold.mb-15 {{ _("Your feedback") }}
      validation-observer(
        tag="form"
        ref="observer"
        v-slot="props"
        @submit.prevent="validateBeforeSubmit"
      )
        +b.ug-row.--offset_sm
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              name="author"
              rules="required"
            )
              ui-input(
                v-model='formdata.author',
                type='text',
                :errors="errors"
                :label='_("Full Name")'
              )
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              name="title"
              rules="required"
            )
              ui-input(
                v-model='formdata.title',
                type='text',
                :errors="errors"
                :label='_("Feedback Title")'
              )
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              name="review"
              rules="required"
            )
              +b.control
                +e.elements
                  +b.control-input.--textarea
                    +b.TEXTAREA.control-textarea(
                      v-model='formdata.review',
                      name='review',
                    )
                  +e.label(:class= "{'is-active': formdata.review.length > 0}")
                    label {{ _("Your comment") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
                
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              name="stars"
              rules="required"
            )
              +b.control
                +e.elements
                  star-rating(
                    :increment= "1",
                    :round-start-rating="false",
                    :star-size= "18",
                    v-model="formdata.stars"
                    active-color= "#fde211",
                    :fixed-points= "1",
                  )
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          validation-provider(
            tag="div"
            v-slot="{errors}"
            name="nonFieldErrors"
          )
            +b.ug-cell.ug-cols
              +b.control.mb-20(v-if="errors[0]")
                +e.meta
                  +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols
            +b.A.button(@click.prevent="validateBeforeSubmit") {{ _("Send review") }}
</template>

<script>
import mixinValidate from '@/js/mixins/formValidate'
import mixinErrors from '@/js/mixins/showErrors'
import InfoModal from '@/js/components/Modals/InfoModal'
export default {
  props: {
    url: String,
    quoteInfo: {},
  },
  mixins: [
    mixinValidate,
    mixinErrors,
  ],
  data() {
    return {
      formdata: {
        review: '',
      }
    }
  },
  methods: {
    send() {
      this.api.post(this.url, this.formdata).then(res => {
        this.$emit('close')
        this.$modal.show(InfoModal, {
          title: this._("Thansk for review."),
        }, {
          height: 'auto',
          transition: "nice-modal-fade",
          scrollable: true
        }, {
          'before-close': () => {
            window.location.reload()
          }
        })
      }).catch(error => {
        let {data} = error.response
        this.showErrors(data)
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/Review.vue